import { ColorSystem } from "../colors/color";
import { button2Styles } from "./button2Styles";
import { cardStyles } from "./cardStyles";
import { PStyling, SmallStyling } from "./typography";

export const amorgStyles = (color:ColorSystem) => 
({
    P:PStyling,
    Small:SmallStyling,
    
    card:cardStyles(color),
    button2:button2Styles(color)
});

export type AmorgStyles = ReturnType<typeof amorgStyles>;